import { DatePipe, registerLocaleData, TitleCasePipe } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import * as countdown from 'countdown';
import firebase from 'firebase/app';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { Tutor } from '../core/clases/tutor.model';
import { CodigosPostales } from '../core/utilidades/codigos-postales';
import { BillableConceptsService } from '../shared/services/billable_concepts/billable-concepts.service';
import { InscripcionService } from '../shared/services/inscripcion/inscripcion.service';
import { PagoService } from '../shared/services/pago/pago.service';
import { RedsysService } from '../shared/services/redsys/redsys.service';
import { SeriesService } from '../shared/services/series/series.service';
import { TutorService } from '../shared/services/tutor/tutor.service';
import { SendEmailService } from './../shared/services/email/send-email.service';
import * as moment from 'moment';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@Component({
  selector: 'app-pago',
  templateUrl: './pago.component.html',
  styleUrls: ['./pago.component.scss']
})
export class PagoComponent implements OnInit {

  tutor = new Tutor();
  tutorAux: any;
  alumnos: Array<any> = [];
  metodosPago: Array<any> = [];
  conceptosCostos: Array<any> = [];
  regexDNI = '^[0-9]{8}[A-Z]$';
  regexNIE = '^[A-Z]{1}[0-9]{7}[A-Z]$';
  regexPasaporte = '';
  banderaBotonSiguiente = true;
  banderaFinalizacion = true;
  iban1;
  iban2;
  iban3;
  iban4;
  iban5;
  fechaAMostrar;
  documentoValido = true;
  ibanValido = true;
  visibleSepa = true;
  validacionTipo = new FormGroup({
    tipoPago: new FormControl()
  });
  powerOffIcon = faPowerOff;

  tipoPagoList = [{
    id: 'tarjeta',
    name: 'Tarjeta - Aplica promoción <a href="#" class="text-secondary" for="flexCheckDefault" data-toggle="modal" data-target="#exampleModal2"><u>Tarjeta 5</u></a>'
  },
  {
    id: 'domiciliacion',
    name: 'Domiciliación bancaria'
  }];

  campoNombre = new FormControl('', [
    Validators.required,
  ]);
  campoDireccion = new FormControl('', [
    Validators.required,
  ]);
  campoZip = new FormControl('', [
    Validators.required,
    Validators.pattern('^[0-9]{5}$'),
    Validators.minLength(5)
  ]);
  campoMunicipio = new FormControl('', [
    Validators.required,
  ]);
  campoProvincia = new FormControl('', [
    Validators.required,
  ]);
  campoPais = new FormControl('', [
    Validators.required,
  ]);
  campoFecha = new FormControl('', [
    Validators.required,
  ]);

  validacionIban1 = new FormControl('', [
    Validators.required,
  ]);
  validacionIban2 = new FormControl('', [
    Validators.required,
  ]);
  validacionIban3 = new FormControl('', [
    Validators.required,
  ]);
  validacionIban4 = new FormControl('', [
    Validators.required,
  ]);
  validacionIban5 = new FormControl('', [
    Validators.required,
  ]);

  validacionDNI = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexDNI),
  ]);
  validacionNIE = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexNIE),
  ]);
  validacionPasaporte = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexPasaporte),
  ]);

  campoNumeroDocumento = this.validacionDNI;

  codigosPostalesMap = new Map();

  valorTotalDescuentos = 0;
  valorTotal = 0;
  valorTotalAPagar = 0;
  numeroRecibo = 0;
  banderaTiempoCargaConceptos = true;
  dsMerchantParameters: any;
  dsSignature: any;
  numeroOrder: any;
  cargando = false;
  cargandoSpinnerPagar = false;
  progreso: number;
  selectFormaPago = false;
  redsysDatos = {};


  constructor(private pagoService: PagoService,
              private tutorService: TutorService,
              private billableConceptsService: BillableConceptsService,
              public datepipe: DatePipe,
              public firebaseAuth: FirebaseAuthComponent,
              private inscripcionService: InscripcionService,
              private seriesService: SeriesService,
              private emailService: SendEmailService,
              public redsysService: RedsysService,
              protected route: ActivatedRoute,
              protected router: Router,
              private titlecasePipe: TitleCasePipe,
              private cd: ChangeDetectorRef) {

     }




  ngOnInit(): void {
    // this.tutor.id = 'i6198QHT3GgUhC4riDk3CofrEY93';
    // this.tutor.email = 'jufena84@gmail.com';
    // tslint:disable-next-line: deprecation
    this.setProgress(25);
    this.billableConceptsService.getBillableConceptsCollection().subscribe(res => {
      this.conceptosCostos = res;
      if (this.banderaTiempoCargaConceptos && this.tutor.id != null) {
        this.obtenerTutor(this.tutor.id);
      }
      this.setProgress(30);
    });
    if (localStorage.getItem('idTutor') != null){
      this.tutor.id = localStorage.getItem('idTutor');
      if (this.conceptosCostos.length > 0) {
        this.banderaTiempoCargaConceptos = false;
        this.obtenerTutor(this.tutor.id);
      }
      this.setProgress(35);
    }else{
      this.tutorService.currentIdTutor$.subscribe(res => {
        this.tutor.id = res;
        localStorage.setItem('idTutor', this.tutor.id);
        if (this.conceptosCostos.length > 0) {
          this.banderaTiempoCargaConceptos = false;
          this.obtenerTutor(this.tutor.id);
        }
        this.setProgress(35);
      });
    }
    //this.obtenerTutor('AbEUD3l44mQEzqQhZ9n1gnCs57f2');
    this.tutor.documentTitular = 'DNI';
    let id = this.route.snapshot.params['idTutor'];
    if (id) {
      this.obtenerTutor(id);
    } else {
      // this.obtenerTutor('L1jBiWE5fZPhMeYGNnnA3kbC7cp1');
      // tslint:disable-next-line: deprecation
      this.tutorService.currentIdTutor$.subscribe(res => {
        this.tutor.id = res;
        if (this.conceptosCostos.length > 0) {
          this.banderaTiempoCargaConceptos = false;
          this.obtenerTutor(this.tutor.id);
        }
      });
    }
    this.setProgress(40);
    this.pagoService.getCountReceipts().subscribe(res => {
      this.numeroRecibo = res.docs.length + 1;
    });
    this.tutor.documentTitular = 'DNI';
    this.tutor.dateTitular = new Date();
    this.fechaAMostrar = this.datepipe.transform(this.tutor.dateTitular, 'dd/MM/yyyy', null);
    this.codigosPostalesMap = new CodigosPostales().codigosPostalesMap;
    this.tutor.paymentType = 'Pago recurrente';

    if (this.validacionTipo.get('tipoPago')) {
      this.validacionTipo.get('tipoPago').valueChanges.subscribe(async value => {
        this.setProgress(60);
        this.cargando = true;
        if (value) {
          this.visibleSepa = value == 'tarjeta' ? false : true;
          this.selectFormaPago = value == 'tarjeta' ? false : true;
          this.redsysDatos = {};
          this.redsysDatos[`total`] = this.valorTotalAPagar;
          this.redsysDatos[`numberOrder`] = `${this.getnumberRandom()}`;
          this.redsysDatos[`namefullTutor`] = this.tutorAux[`fullname`];
          this.redsysDatos[`nameTutor`] = this.tutorAux[`firstname`];
          this.redsysDatos[`emailTutor`] = this.tutorAux[`email`];
          this.redsysDatos[`phoneTutor`] = this.tutorAux[`phone1`];
          this.redsysDatos[`expiryDate`] = this.expiryDate();
          this.redsysDatos[`idTutor`] = this.tutor.id;
          let nombreAlumnos = '';
          this.alumnos.forEach(alumno => {
            nombreAlumnos = nombreAlumnos !== '' ? `${nombreAlumnos} - ${alumno.fullname}` : alumno.fullname;
          });
          this.redsysDatos[`nameStudent`] = nombreAlumnos;
          await this.generarResys();
          this.incluirYEliminarDescuentoTarjeta();
          this.cargando = false;
        }
      });
    }
    this.setProgress(100);
  }

  private async generarResys() {
    const result = await this.redsysService.generarEnvioRedsys(this.redsysDatos);
    if (result['Ds_SignatureVersion'] && result['Ds_MerchantParameters'] && result['Ds_Signature']) {
      this.dsMerchantParameters = result['Ds_MerchantParameters'];
      this.dsSignature = result['Ds_Signature'];
      this.selectFormaPago = true;
    } else {
      const retry = await this.redsysService.generarEnvioRedsys(this.redsysDatos);
      if (retry['Ds_SignatureVersion'] && retry['Ds_MerchantParameters'] && retry['Ds_Signature']) {
        this.dsMerchantParameters = retry['Ds_MerchantParameters'];
        this.dsSignature = retry['Ds_Signature'];
        this.selectFormaPago = true;
      }
    }
  }

  getnumberRandom(): any {
    return Math.round(Math.random() * (999999999999 - 100000000000) + 100000000000);
  }

  expiryDate(): any {
    const months = moment().month();
    const years = moment().year();
    const dia = moment().date();
    const dateExpiry = moment(new Date(years, months, dia + 2, 5, 59, 0)).format('YYYY-MM-DD-hh.mm.ss.SSS');
    return dateExpiry;
  }

  incluirYEliminarDescuentoTarjeta(): void {
    this.valorTotalAPagar = 0;
    this.valorTotalDescuentos = 0;
    this.valorTotal = 0;

    if (this.visibleSepa) {
      let noVariosAlumnos = true;
      this.alumnos.forEach(alumno => {
        if (noVariosAlumnos) {
          this.obtenerConceptosCostosAlumno(alumno);
          noVariosAlumnos = false;
        } else {
          this.obtenerConceptosCostosAlumno(alumno);
          this.establecerConceptosAlumno(alumno, 'YG4oyAmRgYn11jm4y4GZ');
        }
      });
    } else {
      let noVariosAlumnos = true;
      this.alumnos.forEach(alumno => {
        if (noVariosAlumnos) {
          this.obtenerConceptosCostosAlumno(alumno);
          if (alumno.idDescuentoFecha == null || alumno.idDescuentoFecha == '') {
            this.establecerConceptosAlumno(alumno, 'RTT9zmOGPS2eoDc63SAN');
          }
          noVariosAlumnos = false;
        } else {
          this.obtenerConceptosCostosAlumno(alumno);
          if (alumno.idDescuentoFecha == null || alumno.idDescuentoFecha == '') {
            this.establecerConceptosAlumno(alumno, 'RTT9zmOGPS2eoDc63SAN');
          }
          this.establecerConceptosAlumno(alumno, 'YG4oyAmRgYn11jm4y4GZ');
        }
      });
    }
    this.redsysDatos[`total`] = this.valorTotalAPagar;
    this.generarResys();
    this.cargando = false;
  }

  obtenerConceptosCostosAlumno(alumno): void {
    alumno.valorTotal = 0;
    alumno.totalDescuentos = 0;
    alumno.idBillableConcepts = [];
    alumno.billable = [];
    alumno.idDescuentoFecha = null;
    this.asignarDescuentoPorFecha(alumno);
    alumno.billableConceptsStudent.filter(bill => {
      const billSpli = bill.idCourse.split('/');
      if (alumno.idLastCourse === billSpli[1]) {
        return bill;
      }
    }).orElse([{billableConcepts: []}])[0]
    .billableConcepts.forEach(concepto => {
      this.establecerConceptosAlumno(alumno, concepto.id);
    });

    if (alumno.idDescuentoFecha != null && alumno.idDescuentoFecha != '') {
      this.establecerConceptosAlumno(alumno, alumno.idDescuentoFecha);
    }
  }

  establecerConceptosAlumno(alumno, idConcepto): void {
    this.conceptosCostos.forEach(element => {
      if (element.id == idConcepto) {
        alumno.billable.push({
          amount: element.amount,
          billableConcepts: 'billable_concepts/' + element.id,
          billableConceptsDescription: element.concept,
          discount: 0,
          iva: element.iva,
          netPayment: element.total
        });
        alumno.idBillableConcepts.push(firebase.firestore().doc(`/billable_concepts/${element.id}`));
        this.calcularTotalesConceptos(alumno, element);
      }
    });
  }

  private establecerNumeroRecibo(alumno: any, numeroRecibo): void {
    if (numeroRecibo < 100) {
      alumno.numeroRecibo = '00' + numeroRecibo;
    } else {
      if (numeroRecibo < 1000) {
        alumno.numeroRecibo = '0' + numeroRecibo;
      }
      else {
        alumno.numeroRecibo = numeroRecibo;
      }
    }
  }

  obtenerMunicipioXCodigoPostal(codigoPostal): void {
    this.tutor.cityTitular = '';
    this.tutor.countryTitular = '';
    this.tutor.municipalityTitular = this.codigosPostalesMap.get(codigoPostal);
    if (this.tutor.municipalityTitular != null && this.tutor.municipalityTitular !== '') {
      this.tutor.cityTitular = 'Sevilla';
      this.tutor.countryTitular = 'España';
    }
  }

  guadarInfoDomiciliacionBancaria(): void {
    if (this.ibanValido) {
      this.aplicarTitlecasePipe();
      this.cargandoSpinnerPagar = true;
      this.tutor.paymentMethod = 'hKSTnko61Cqbt7OjUApa';
      this.tutor.IBAN = 'ES' + this.iban1 + this.iban2 + this.iban3 + this.iban4 + this.iban5;
      this.tutorService.updateDomiciliacionBancaria(this.tutor).then(() => {
        this.actualizarEstadoAlumnosYRecibo();
      }).catch((error) => {
        console.log('error domiciliacion tutor  ' + error);
        this.cargandoSpinnerPagar = false;
      });
    }
  }

  aplicarTitlecasePipe(): void {
    this.tutor.titularPayment = this.titlecasePipe.transform(this.tutor.titularPayment);
    this.tutor.addressTitular = this.titlecasePipe.transform(this.tutor.addressTitular);
    this.tutor.municipalityTitular = this.titlecasePipe.transform(this.tutor.municipalityTitular);
    this.tutor.cityTitular = this.titlecasePipe.transform(this.tutor.cityTitular);
    this.tutor.countryTitular = this.titlecasePipe.transform(this.tutor.countryTitular);
  }

  async actualizarEstadoAlumnosYRecibo(): Promise<void> {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.alumnos.length; i++) {
      await this.obtenerSerieYActualizar(this.alumnos[i]);
    }
    this.cargandoSpinnerPagar = false;
    this.banderaFinalizacion = false;
  }

  private async accionesPagar(alumno: any): Promise<void> {
    try {
      await this.pagoService.insertarRecibo(alumno, this.tutor).then(async () => {
      }).catch(
        (error) => {
          this.cargandoSpinnerPagar = false;
          console.log('fallo la generación del recibo ' + error);
          throw error;
        }
      );
      await this.tutorService.updateUserStatusFinishInscription(alumno, 'matriculado').then(async () => {
        alumno.lastStatusCourses.courseStatus = 'matriculado';
        alumno.lastStatusCourses.statusStudentCourse = 'matriculado';
        alumno.status = 'matriculado';
        await this.tutorService.setLastStatusCourse(alumno).then(async () => {
        }).catch((error) => {
          this.cargandoSpinnerPagar = false;
          console.log('error al cambiar el statusCourse a matriculado ' + error);
          throw error;
        });
      }).catch((error) => {
        this.cargandoSpinnerPagar = false;
        console.log('error al cambiar el estado a matriculado ' + error);
        throw error;
      });
      await this.inscripcionService.actualizarEstadoInscripcion(alumno.inscripcionId, 'matriculado').then(async () => {
      }).catch((error) => {
        this.cargandoSpinnerPagar = false;
        console.log('error al cambiar el estado a matriculado ' + error);
        throw error;
      });
      await alumno.courses.filter(cour => cour.id === alumno.idLastCourse)
      .orElse([{ get: () => {
          return { then: () => {} };
        }
      }])[0].get().then(async course => {
        const courseData = course.data();
        const centro = await courseData.center.get();
        const centroData = centro.data();
        const municipio = await centroData.town.get();
        const municipioData = municipio.data();
        // if (this.alumnos[this.alumnos.length] == alumno) {
        //   this.cargando = false;
        // }
        // console.log('los datos son ', courseData, ' ', centroData, ' ', municipioData);
        this.enviarEmail('Confirmación de matrícula',
          this.emailMatricula(alumno?.fullname, courseData, centroData, municipioData),
          this.tutorAux.email);
      });
      /*await alumno.courses[0].get().then(async course => {
        const courseData = course.data();
        const centro = await alumno.centro[0].get();
        const centroData = centro.data();
        const municipio = await centroData.town.get();
        const municipioData = municipio.data();
        // if (this.alumnos[this.alumnos.length] == alumno) {
        //   this.cargando = false;
        // }
        // console.log('los datos son ', courseData, ' ', centroData, ' ', municipioData);
        this.enviarEmail('Confirmación de matrícula',
          this.emailMatricula(alumno?.fullname, courseData, centroData, municipioData),
          this.tutorAux.email);
      });*/
    } catch (error) {
      console.log(error);
    }

  }

  // Cargar tutor y estudiante creados
  obtenerTutor(id): void {
    const observableTutor = this.tutorService.getUser(id).subscribe(res => {
      observableTutor.unsubscribe();
      this.tutorAux = res;
      this.tutor.id = this.tutorAux.id;
      if (this.tutorAux != null) {
        this.establecerDatosAlumnos(this.tutorAux.alumns);
        this.inicializarContador(this.tutorAux);
      }
    });
  }


  establecerDatosDomicialicionTutor(tutorBD): void {
    if (tutorBD.IBAN != null) {
      this.tutor.IBAN = tutorBD?.IBAN || '';
      this.iban1 = tutorBD.IBAN.substring(2, 2);
      this.iban2 = tutorBD.IBAN.substring(4, 4);
      this.iban3 = tutorBD.IBAN.substring(8, 4);
      this.iban4 = tutorBD.IBAN.substring(12, 2);
      this.iban5 = tutorBD.IBAN.substring(14, 10);
    }
    this.tutor.titularPayment = tutorBD?.titularPayment || '';
    this.tutor.documentTitular = tutorBD?.documentTitular || '';
    this.tutor.numberDNITitular = tutorBD?.numberDNITitular || 'DNI';
    this.tutor.addressTitular = tutorBD?.addressTitular || '';
    this.tutor.zipTitular = tutorBD?.zipTitular || '';
    this.tutor.municipalityTitular = tutorBD?.municipalityTitular || '';
    this.tutor.cityTitular = tutorBD?.cityTitular || '';
    this.tutor.countryTitular = tutorBD?.countryTitular || '';
    this.tutor.swiftBicTitular = tutorBD?.swiftBicTitular || '';
    this.tutor.countryTitular = tutorBD?.countryTitular || '';

  }

  establecerDatosAlumnos(alumnosTutor): void {
    if (alumnosTutor != null) {
      alumnosTutor.forEach(element => {
        this.cargando = true;
        this.tutorService.getUser(element.id).subscribe(res => {
          this.agregarAlumno(res);
        });
      });
    }
    //console.log(this.alumnos);
  }

  agregarAlumno(alumno): void {
    let banderaInsertar = true;
    this.alumnos.forEach(element => {
      if (element.id == alumno.id) {
        banderaInsertar = false;
      }
    });
    if (banderaInsertar) {
      if (alumno.status != 'test' && alumno.status != 'matriculado' && alumno.status != 'espera' && alumno.status != 'ninguno') {
        this.alumnos.push(alumno);
        this.obtenerConceptosCostosAlumno(alumno);
      }
    }
    this.cargando = false;
  }

  calcularTotalesConceptos(alumno, concepto): void {
    let cantidad: number;
    cantidad = Number(concepto.total);
    if (cantidad < 0) {
      this.valorTotalDescuentos = this.valorTotalDescuentos + cantidad;
      alumno.totalDescuentos = alumno.totalDescuentos + cantidad;
    } else {
      this.valorTotal = this.valorTotal + cantidad;
      alumno.valorTotal = alumno.valorTotal + cantidad;
    }
    alumno.valorTotalAPagar = alumno.totalDescuentos + alumno.valorTotal;
    this.valorTotalAPagar = this.valorTotalDescuentos + this.valorTotal;
  }

  logout(): void {
    this.firebaseAuth.eliminarInscripcionesAlumnos(this.alumnos);
    this.firebaseAuth.logout();
    localStorage.removeItem('idTutor');
  }

  actualizarIdTutor(): void {
    setTimeout(() => {
      this.tutorService.changeIdTutor(this.tutor.id);
    }, 500);
  }

  inicializarContador(tutor): void {
    tutor.timeId = countdown(tutor.courseSelectedTime, (ts) => {
      tutor.time = ts;
      if ((tutor.time.minutes === 0) && (tutor.time.seconds === 0)){
        console.log('contador llego a cero en pago');
        this.logout();
      }
      this.cambiarSegundoADosDigitos(tutor.time.seconds, tutor);
      this.cargando = false;
    });
  }

  async obtenerSerieYActualizar(alumno): Promise<void> {
    // tslint:disable-next-line: deprecation
    let serieAux;
    await this.seriesService.getSerie(alumno.idLastSerie).then(async serie => {
      serieAux = serie.data();
    });
    let numeroRecibo = 0;
    const accounting = alumno.billableConceptsStudent.filter(bill => {
      const billSpli = bill.idCourse.split('/');
      if (alumno.idLastCourse === billSpli[1]) {
        return bill;
      }
    }).orElse([{accounting: ''}])[0].accounting;

    if (accounting == 'recibo') {
      numeroRecibo = serieAux?.counter + 1;
      alumno.nameSerie = serieAux?.name;
      await this.actualizarSerieCounter(alumno.idLastSerie, numeroRecibo);
    } else {
      numeroRecibo = serieAux?.counterFactura + 1;
      await this.actualizarSerieCounterFactura(alumno.idLastSerie, numeroRecibo);
      alumno.nameSerie = serieAux?.name;
    }
    this.establecerNumeroRecibo(alumno, numeroRecibo);
    await this.accionesPagar(alumno);
    this.cargandoSpinnerPagar = false;
  }
  async actualizarSerieCounter(idSerie, numeroRecibo): Promise<void> {
    // tslint:disable-next-line: deprecation
    await this.seriesService.updateCounter(idSerie, numeroRecibo).then(serie => {
    }).catch(
      (error) => {
        console.log('fallo actualizacion de la serie' + error);
      }
    );
  }
  async actualizarSerieCounterFactura(idSerie, numeroRecibo): Promise<void> {
    // tslint:disable-next-line: deprecation
    await this.seriesService.updateCounterFactura(idSerie, numeroRecibo).then(serie => {
    }).catch(
      (error) => {
        console.log('fallo actualizacion de la serie' + error);
      }
    );
  }

  validarDoc(numeroDocumento): void {
    if (numeroDocumento != null) {
      this.documentoValido = true;
      if (this.tutor.documentTitular == 'DNI') {
        this.validarDNI(numeroDocumento);
      }
      if (this.tutor.documentTitular == 'NIE') {
        let niePrefix = numeroDocumento.charAt(0);
        switch (niePrefix) {
          case 'X': niePrefix = 0; break;
          case 'Y': niePrefix = 1; break;
          case 'Z': niePrefix = 2; break;
        }
        this.validarDNI(niePrefix + numeroDocumento.substr(1));
      }
    }
  }

  validarDNI(dni): void {
    const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const letter = dniLetters.charAt(parseInt(dni, 10) % 23);
    this.documentoValido = letter == dni.charAt(8);
  }

  validarIBAN(): void {
    this.tutor.IBAN = 'ES' + this.iban1 + this.iban2 + this.iban3 + this.iban4 + this.iban5;
    let IBAN = this.tutor.IBAN;
    IBAN = IBAN.trim();
    let letra1;
    let letra2;
    let num1;
    let num2;
    let isbanaux;

    if (IBAN.length !== 24) {
      this.ibanValido = false;
    }
    letra1 = IBAN.substring(0, 1);
    letra2 = IBAN.substring(1, 2);
    num1 = this.getnumIBAN(letra1);
    num2 = this.getnumIBAN(letra2);

    isbanaux = String(num1) + String(num2) + IBAN.substring(2);
    isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);

    const resto = this.modulo97(isbanaux);
    if (resto == 1) {
      this.ibanValido = true;
    } else {
      this.ibanValido = false;
    }
  }

  modulo97(iban): any {
    const parts = Math.ceil(iban.length / 7);
    let remainer = '';

    for (let i = 1; i <= parts; i++) {
      remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
    }

    return remainer;
  }

  getnumIBAN(letra): any {
    const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return letras.search(letra) + 10;
  }

  enviarEmail(subjectToSend: string, messageToSend: string, emailToSend: string): Promise<any> {
    return this.emailService.sendEmail(subjectToSend, messageToSend, emailToSend)
      .then((responseSus) => {
        // console.log('el resultado de la function es ', responseSus);
        if (responseSus) {
          if (responseSus.error) {
          }
        }
        return responseSus;
      }).catch(error => {
      });
  }

  emailMatricula(nombreAlumno: string, course: any, centro: any, municipio: any): string {
    const messageEmail = `<div style ="text-align: justify;">
    Hola ${this.tutorAux.fullname}<br/>

    la matrícula de ${nombreAlumno} ha sido completada correctamente.<br/><br/>

    Centro: ${centro.description} - ${municipio.municipality}<br/><br/>

    Curso: ${course.description}<br/><br/>

    Día: ${course.weekDays[0]}<br/><br/>

    Hora: ${course.startTime.hour}:${course.startTime.minute}-${course.endTime.hour}:${course.endTime.minute}<br/><br/>

    Gracias por tu matrícula.<br/>

    <img class="product-image" style="max-width: 100%;"
    src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
    <br/><br/>

    Avda. de las Civilizaciones 15, local 9<br/>
    41927 Mairena del Aljarafe, Sevilla<br/>
    Tlf.: 854993164 - info@playbots.es<br/><br/>

    Este correo electrónico y, en su caso, cualquier fichero anexo, contiene información confidencial <br/>
    exclusivamente dirigida a su(s) destinatario(s). Toda copia o divulgación deberá ser autorizada por <br/>
    Playbots Education S.L. <br/><br/>

    This e-mail and any attachments are confidential and exclusively directed to its address(es). Any<br/>
    copy or distribution will have to be authorized by Playbots Education S.L.<br/><br/>

    En virtud de la ley 34/2002 LSSI-CE, este mensaje y sus archivos adjuntos pueden contener<br/>
    información confidencial, por lo que se informa de que su uso no autorizado está prohibido por la<br/>
    ley, además se encuentran protegidos por la Constitución Española, que garantiza la<br/>
    confidencialidad, protección y secreto de las comunicaciones. Si ha recibido este mensaje por<br/>
    equivocación, por favor notifíquelo inmediatamente a través de esta misma vía y borre el mensaje<br/>
    original junto con sus ficheros adjuntos sin leerlo o grabarlo total o parcialmente. Los datos<br/>
    personales que consten en esta comunicación son responsabilidad de Playbots Education S.L.<br/>
    con la finalidad de gestionar la relación con nuestros clientes y contactos en relación al ejercicio<br/>
    de nuestra actividad, todo ello bajo la legitimación otorgada por consentimiento expreso del propio<br/>
    interesado, y/o en base a la ejecución de un contrato de servicios. No se cederán datos a terceros<br/>
    salvo obligaciones legales. En cuanto a sus derechos podrá acceder, rectificar y suprimir los datos,<br/>
    limitarlos o incluso oponerse a su tratamiento, entre otros derechos, contactando con nosotros por<br/>
    email o por correo postal dirigido a Avda. de las Civilizaciones 15, local 9 - 41927 Mairena del<br/>
    Aljarafe, Sevilla.<br/><br/>

    </div>`;

    return messageEmail;
  }

  asignarDescuentoPorFecha(alumno): void {

    let idDescuento: string;
    try {
      const endDateLastCourse = this.segundosToDateUTC(alumno.endDateLastCourse.seconds);
      const primerDia = new Date();
      let ultimoDia = new Date(primerDia.getFullYear(), primerDia.getMonth() + 1, 0);
      const diaSemana = this.obtenerNumeroDia(alumno.dayLastCourse);
      const hora = alumno.starTimeLastCourse.hour;
      const distance = diaSemana - primerDia.getDay();
      if (distance >= 0) {
        primerDia.setDate(primerDia.getDate() + distance);
      } else {
        primerDia.setDate(primerDia.getDate() + distance + 7);
      }
      primerDia.setHours(hora);
      primerDia.setMinutes(0);
      if ((endDateLastCourse.getFullYear() == primerDia.getFullYear())
        && (endDateLastCourse.getMonth() == primerDia.getMonth())) {
        ultimoDia = endDateLastCourse;
      }
      ultimoDia.setHours(23);
      ultimoDia.setMinutes(59);
      if (primerDia < ultimoDia) {
        primerDia.setDate(primerDia.getDate() + 7);
        if (primerDia < ultimoDia) {
          primerDia.setDate(primerDia.getDate() + 7);
          if (primerDia < ultimoDia) {
            primerDia.setDate(primerDia.getDate() + 7);
            if (primerDia < ultimoDia) {
            } else {
              idDescuento = 'AN9nXvyp6oDb4rSDikPM';
            }
          } else {
            idDescuento = 'qnxWGjE89SWBTfN8quoh';
          }
        } else {
          idDescuento = 'zJkJVTzf711n3HIlvRPa';
        }
      }
    } catch (e) {
      console.log(e);
    }
    alumno.idDescuentoFecha = idDescuento;
  }

  segundosToDateUTC(secs): Date {
    const t = new Date(Date.UTC(1970, 0, 1));
    t.setUTCSeconds(secs);
    return t;
  }

  obtenerNumeroDia(dia: string): number {
    let numeroDia: number;
    switch (dia) {
      case 'Lunes':
        numeroDia = 1;
        break;
      case 'Martes':
        numeroDia = 2;
        break;
      case 'Miercoles':
        numeroDia = 3;
        break;
      case 'Jueves':
        numeroDia = 4;
        break;
      case 'Viernes':
        numeroDia = 5;
        break;
      case 'Sabado':
        numeroDia = 6;
        break;
      case 'Domingo':
        numeroDia = 0;
        break;
      default:
        numeroDia = 1;
        break;
    }
    return numeroDia;

  }

  numeroDiaEnElMes(year, month, numeroDia): number {

    let day;
    let counter;
    let date;
    day = 1;
    counter = 0;
    date = new Date(year, month, day);
    while (date.getMonth() === month) {
      if (date.getDay() === numeroDia) {
        counter += 1;
      }
      day += 1;
      date = new Date(year, month, day);
    }
    return counter;
  }

  cambiarSegundoADosDigitos(segundo, tutor): void {
    switch (segundo) {
      case 0:
        tutor.time.seconds = '00';
        break;
      case 1:
        tutor.time.seconds = '01';
        break;
      case 2:
        tutor.time.seconds = '02';
        break;
      case 3:
        tutor.time.seconds = '03';
        break;
      case 4:
        tutor.time.seconds = '04';
        break;
      case 5:
        tutor.time.seconds = '05';
        break;
      case 6:
        tutor.time.seconds = '06';
        break;
      case 7:
        tutor.time.seconds = '07';
        break;
      case 8:
        tutor.time.seconds = '08';
        break;
      case 9:
        tutor.time.seconds = '09';
        break;
      default:
        break;
    }
  }
  onChangeDocumento(event) {
    switch (event) {
      case 'DNI':
        this.campoNumeroDocumento = this.validacionDNI;
        break;
      case 'NIE':
        this.campoNumeroDocumento = this.validacionNIE;
        break;
      case 'Pasaporte':
        this.campoNumeroDocumento = this.validacionPasaporte;
        break;
    }

    this.tutor.numberDNI = '';
    this.campoNumeroDocumento.reset();
  }

  setProgress(percent: number) {
    this.progreso = percent;
    this.cargando = percent < 100;
    this.cd.markForCheck();
    this.cd.detectChanges();
  }

}
